import { render, staticRenderFns } from "./ShopCategories.vue?vue&type=template&id=dd4807a8&scoped=true&"
import script from "./ShopCategories.vue?vue&type=script&lang=js&"
export * from "./ShopCategories.vue?vue&type=script&lang=js&"
import style0 from "./ShopCategories.vue?vue&type=style&index=0&id=dd4807a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4807a8",
  null
  
)

export default component.exports